var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c("SearchTerm", {
        attrs: {
          searchInfo: _vm.searchInfo,
          searchMore: true,
          searchBaseItems: [
            "sellerId",
            "shiftDate",
            "createdAtStart",
            "mobile"
          ],
          btns: { search: true, reset: true, download: _vm.downloading }
        },
        on: { onChange: _vm.onSearchChange }
      }),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          small: "",
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark",
            height: "45rem"
          }
        },
        [
          _c("el-table-column", {
            attrs: { label: "赠送日期", prop: "createdAt" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("formatDatePayAt")(scope.row.giftCreatedAt))
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "站点", prop: "sellerName" }
          }),
          _c("el-table-column", {
            attrs: { label: "主订单号", prop: "mainOrderNo", width: "300" }
          }),
          _c("el-table-column", {
            attrs: { label: "赠品", prop: "giftGoodsName", width: "300" }
          }),
          _c("el-table-column", {
            attrs: { label: "赠送数量", prop: "giftGoodsNum" }
          }),
          _c("el-table-column", {
            attrs: { label: "条码", prop: "giftGoodsNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "消费油品", prop: "orderGoodsType" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v("#" + _vm._s(scope.row.orderGoodsType))]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "消费金额", prop: "orderSaleAmount" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }